if (!process.env.REACT_APP_GOOGLE_API_KEY) {
  throw new Error(`Environment variable REACT_APP_GOOGLE_API_KEY is not defined`);
}

export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
